(function($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.service('thfValidateItems', function() {
        function validateItem(validationRules, model, item, tabModel, globalModel, formState) {
            var validationResponse = {
                result: true,
                message: ''
            };

            var value = ( typeof model[item.name] !== 'undefined' )
                ? model[item.name]
                : '';

            if (validationRules[item.name] && validationRules[item.name].length > 0) {
                for (var i = 0; i < validationRules[item.name].length; i++) {
                    validationResponse = THF.Utility.Validation.validateRule(validationRules[item.name][i], value, item.validationMessage, {
                        field: item,
                        model: angular.copy(tabModel),
                        globalModel: angular.copy(globalModel),
                        formState: formState
                    });

                    if( !validationResponse.result ) {
                        break;
                    }
                }
            }
            return validationResponse;
        }

        return function thfValidateItems(validationRules, validateField, validateModel, validateValidation, globalModel, formState, setFieldValidation) {
            var isValid = true;
            setFieldValidation = (typeof setFieldValidation !== 'undefined') ? setFieldValidation : true;
            if (typeof validateField === 'object') {
                var k;
                for (k in validateField) {
                    if (validateField.hasOwnProperty(k)) {
                        var item = validateField[k];
                        var model = validateModel;
                        var rules = validationRules;
                        if (typeof validateModel !== 'undefined') {
                            if (typeof item.modelChild !== 'undefined') {
                                model = model[item.modelChild];
                                rules = rules[item.modelChild];
                            }

                            if (typeof validateValidation === 'undefined') {
                                validateValidation = {};
                            }

                            // If the model is an instance of an array we want to iterate over the entries and validate the fields that way.
                            var validationResponse;
                            if (model instanceof Array) {
                                for (var i = 0; i < model.length; i++) {
                                    validationResponse = validateItem(rules[i], model[i], item, validateModel, globalModel, formState);

                                    var validation = validateValidation;

                                    if (typeof item.modelChild !== 'undefined') {
                                        validation = validation[item.modelChild];
                                    }

                                    if (typeof validation[i] === 'undefined') {
                                        validation[i] = {};
                                    }

                                    if( setFieldValidation ) {
                                        validation[i][item.name] = validationResponse;
                                    }


                                    if (!validationResponse.result) {
                                        isValid = false;
                                    }
                                }
                            }
                            else {
                                validationResponse = validateItem(rules, model, item, validateModel, globalModel, formState);

                                if( setFieldValidation ) {
                                    if (typeof item.modelChild !== 'undefined') {
                                        validateValidation[item.modelChild][item.name] = validationResponse;
                                    }
                                    else {
                                        validateValidation[item.name] = validationResponse;
                                    }
                                }

                                if (!validationResponse.result) {
                                    isValid = false;
                                }
                            }
                        }
                    }
                }
            }
            return isValid;
        };
    });
})(jQuery, angular, window);
